// This key is not secret so we are fine with checking it into the repo
export const AMPLITUDE_PUBLIC_KEY = "69ddee88aacac6cb029589ad59613b12";
